import axiosClient from "../axios/axiosClient";

export function getPositions() {
  return axiosClient.get("/positions");
}

export function getPosition(positionId) {
  return axiosClient.get(`/positions/${positionId}`);
}

export function createPosition(data) {
  return axiosClient.post("/positions", data);
}

export const updatePosition = (positionId, data) => {
  return axiosClient.put(`/positions/${positionId}`, data);
};

export function deletePosition(positionId) {
  return axiosClient.delete(`/positions/${positionId}`);
}
